import { ThemeToggleBtn } from './Common.jsx'

// Fixed top-right theme toggle for the auth pages (signin / signup / forgot /
// reset / accept-invite / complete-signup). These use the .auth-page layout and
// have no top bar of their own, so the toggle floats in the corner. It reuses the
// same store-backed ThemeToggleBtn as the landing nav and the dashboard Topbar, so
// the choice stays in sync everywhere.
export default function AuthThemeToggle() {
  return (
    <div style={{ position: 'fixed', top: 16, right: 16, zIndex: 50 }}>
      <ThemeToggleBtn width={38} />
    </div>
  )
}
